import React from "react";
import SmallProject from "./SmallProject";
import "./CSS/animation.css";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

function OtherProjects() {
  return (
    <div className="other__projects container-fluid">
      <div className="container">
        <div className="row">
          <div className="col-md-12 otherProjects__title">
            <h3>Other Noteworthy Projects</h3>
            <p>view the archieve</p>
          </div>
        </div>
        <div className="row projects__list">
          <a
            target="_blank"
            href="https://twitter-clone-16828.web.app/"
            className="col-md-4"
          >
            <SmallProject
              title="Twitter Clone"
              description="A clone made by me with react with the help of sonysangha . It has post functionality with awsome ui  with react flip animations all powered with firebase where all post data is stored and the project is hosted . "
              tech="JSX, CSS, React , Firebase"
              projectlink="https://twitter-clone-16828.web.app/"
            />
          </a>
          <a
            target="_blank"
            href="https://amazgfon-clone-2-0.vercel.app/"
            className="col-md-4"
          >
            <SmallProject
              title="Amazon Clone"
              description="A completely responsive amazon clone.  It includes login screen, check-out, items cart.  At main page it has a products sections
                            Then we have login page and cart page.  I also built a nice looking product search bar.
                        ."
              tech="Next js ,React, Firebase, Redux"
            />
          </a>

          <a
            target="_blank"
            href="https://www.property051.com/"
            className="col-md-4"
          >
            <SmallProject
              title="Property-051"
              description="Biulding Islamabad's 1st Digital Real Estate Marketplace from scratch.It is a large scale project with some major features like property,products,projects adding with a portal with edit,update,delete 
functionality
              "
              tech="Laravel ,Bootsrap, HTML, CSS, , MySql"
              projectlink="https://www.property051.com/"
            />
          </a>
        </div>
        <div className="row projects__list">
          <a
            target="_blank"
            href="https://khan-movieapp.netlify.app/"
            className="col-md-4"
          >
            <SmallProject
              title="Movie App"
              description="A movie app that fetches data from the api and displays it in a list. It also has a search bar that searches for movies based on the user input.
                        "
              tech="React"
              projectlink="https://khan-movieapp.netlify.app/"
            />
          </a>
          <a
            target="_blank"
            href="https://etihadcity.pk/"
            className="col-md-4"
            rel="noreferrer"
          >
            <SmallProject
              title="Etihad City"
              description="A completely Responsive Travel website.  It includes Responsive Navigation Bar with toggle effect
                        About Section,
                        NewsLetter Section,
                        Service Section,
                        Trip Section and
                        Contact Section with location map."
              tech="HTML, CSS JavaScript"
              projectlink="https://etihadcity.pk/"
            />
          </a>
          <a
            target="_blank"
            href="https://saud-7039d.web.app/"
            className="col-md-4"
          >
            <SmallProject
              title="Google Clone"
              description="I made this clone using react and an API.  It is totally responsive and as clean like real google.  It uses API to search things.
                          It has two pages home page and search page.  Furhter it go some beautiful animations.
                        "
              tech="React"
              projectlink="https://saud-7039d.web.app/"
            />
          </a>
        </div>

        <Router>
          <Switch>
            <Route path="/projects">
              <div className="row projects__list">
                <a
                  target="_blank"
                  href="https://saud-7039d.web.app/"
                  className="col-md-4"
                >
                  <SmallProject
                    title="Google Clone"
                    description="I made this clone using react and an API.  It is totally responsive and as clean like real google.  It uses API to search things.
                          It has two pages home page and search page.  Furhter it go some beautiful animations.
                        "
                    tech="React"
                    projectlink="https://saud-7039d.web.app/"
                  />
                </a>
                <a target="_blank" href="" className="col-md-4">
                  <SmallProject
                    title="Twitter Clone"
                    description="You can login on this clone using google authentication.  It got features like posting tweets, old tweets, and a beautiful
                    sidebar with options and icons in them.  It also got feature like liking and sharing tweet.  
                        ."
                    tech="JSX, CSS, JavaScript"
                  />
                </a>
                <a target="_blank" href="" className="col-md-4">
                  <SmallProject
                    title="Whatsapp Clone"
                    description="A real whatsapp clone where you can login using google firebase authentication.  Then you can chat with anyone who will login on this clone. 
                            It is responsive but only for browser. It was so much fun.
                        "
                    tech="React, Firebase"
                  />
                </a>
              </div>
            </Route>
          </Switch>

          <div className="row">
            <div className="col-md-12 otherProjects__button">
              <Link to="/projects">
                <button className="btn btn-work">See More</button>
              </Link>
            </div>
          </div>
        </Router>
      </div>
    </div>
  );
}

export default OtherProjects;
